import React, { FC, useState } from "react";
import "./Header.css";
import { Menu } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faFootball,
  faNewspaper,
  faPeopleGroup,
  faUserSecret,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

interface HeaderProps {}

const Header: FC<HeaderProps> = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <header className="md:hidden bg-blue-950 text-white flex items-center justify-between pt-3 pb-4 px-4">
        <h1 className="text-4xl font-bold">Bruin's Board</h1>
        <button onClick={() => setIsOpen(!isOpen)}>
          <Menu className="w-6 h-6" />
        </button>
      </header>

      {isOpen && (
        <div className="md:hidden bg-blue-950 text-white p-4 pt-0 space-y-3">
          <nav className="flex flex-col gap-2">
            <h1 className="text-2xl mb-3">Social</h1>
            <Link
              to="/confessions"
              className="hover:bg-blue-900 text-xl rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faUserSecret} className="mt-1 w-5" />
              Confessions
            </Link>
            <h1 className="text-2xl mb-3 mt-3">Student Union</h1>
            <Link
              to="/clubs"
              className="hover:bg-blue-900 text-xl rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faPeopleGroup} className="mt-1 w-5" />{" "}
              Clubs
            </Link>
            <Link
              to="/events"
              className="hover:bg-blue-900 text-xl rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faCalendarAlt} className="mt-1 w-5" />{" "}
              Events
            </Link>
            <Link
              to="/wip"
              className="hover:bg-blue-900 text-xl rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faNewspaper} className="mt-1 w-5" />{" "}
              Articles
            </Link>
            <Link
              to="/wip"
              className="hover:bg-blue-900 text-xl rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faFootball} className="mt-1 w-5" /> Sports
            </Link>
          </nav>
        </div>
      )}

      <aside className="hidden md:flex w-80 bg-blue-950 text-white min-h-screen flex-col p-2 overflow-y-scroll max-h-screen overflow-x-hidden">
        <h1 className="text-4xl px-3 font-bold text-blue-50 mt-3">
          Bruin's Board
        </h1>
        <h1 className="text-lg px-3 mb-3 text-blue-200">
          Connecting students to students.
        </h1>

        <nav className="flex flex-col gap-1">
          <div className="text-lg">
            <h1 className="px-3 text-2xl mb-3">Social</h1>
            <hr className="mx-3 border-blue-200 opacity-15 mb-1" />
            <Link
              to="/confessions"
              className="hover:bg-blue-900 p-3 rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faUserSecret} className="mt-1 w-5" />
              Confessions
            </Link>
            {/*
              <Link
                to="/wip"
                className="hover:bg-blue-900 p-3 rounded-sm flex gap-3"
              >
                <FontAwesomeIcon icon={faStore} className="mt-1 w-5" />
                Marketplace
              </Link>
              */}
            <h1 className="px-3 text-2xl mb-3 mt-3">Student Union</h1>
            <hr className="mx-3 border-blue-200 opacity-15 mb-1" />
            <Link
              to="/clubs"
              className="hover:bg-blue-900 p-3 rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faPeopleGroup} className="mt-1 w-5" />{" "}
              Clubs
            </Link>
            <Link
              to="/events"
              className="hover:bg-blue-900 p-3 rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faCalendarAlt} className="mt-1 w-5" />{" "}
              Events
            </Link>
            <Link
              to="/wip"
              className="hover:bg-blue-900 p-3 rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faNewspaper} className="mt-1 w-5" />{" "}
              Articles
            </Link>
            <Link
              to="/wip"
              className="hover:bg-blue-900 p-3 rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faFootball} className="mt-1 w-5" /> Sports
            </Link>

            {/*
            <h1 className="px-3 text-2xl mb-3 mt-3">Account</h1>
            <hr className="mx-3 border-blue-200 opacity-15 mb-1" />
            <Link
              to="/wip"
              className="hover:bg-blue-900 p-3 rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faUser} className="mt-1 w-5" /> Profile
            </Link>
            <Link
              to="/events"
              className="hover:bg-blue-900 p-3 rounded-sm flex gap-3"
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="mt-1 w-5" />
              Logout
            </Link>
            */}

            <h1 className="px-3 text-2xl mb-3 mt-3">Sheridan Radio</h1>
            <hr className="mx-3 border-blue-200 opacity-15 mb-3" />
            <div className="overflow-hidden">
              <iframe
                src="https://tunein.com/embed/player/s297925/?background=dark"
                className="radio-player"
                title="Radio"
              ></iframe>
            </div>

            <h1 className="p-3 text-lg mt-6 mx-1 text-center bg-slate-950 opacity-60 italic">
              This website is not endorsed, sponsored, or affiliated with a
              specific college in any way.
            </h1>
          </div>
        </nav>
      </aside>
    </div>
  );
};

export default Header;
